import { Tooltip } from '@mantine/core';
import { IconInfo } from 'ui-icons';

import { Group, Stack } from '../../../Layout';
import { Text } from '../../../Typography';
import { FileUpload, FileUploadProps } from './FileUpload';

interface ImageUploadProps extends FileUploadProps {
  label?: string;
  dimensions: [number, number];
  required?: boolean;
  moreInfo?: string;
}

// We want to reduce the fraction created from the dimensions to specify an aspect ratio a # / #
const reduce = (numerator: number, denominator: number) => {
  const gcd = (num: number, den: number) => {
    return den ? gcd(den, num % den) : num;
  };
  const gcdValue = gcd(numerator, denominator);
  return `${numerator / gcdValue}:${denominator / gcdValue}`;
};

const ImageUpload = ({
  file,
  dimensions,
  label,
  setFile,
  existingSrc,
  setExistingSrc,
  enableCropping,
  required,
  moreInfo,
  ...props
}: ImageUploadProps) => {
  const ratio = reduce(dimensions[0], dimensions[1]);

  return (
    <Stack gap="sm">
      <Group justify="space-between">
        <Text type="sub" fw={500} c="gray">
          {label ?? 'Upload an Image'}
          <Text span c="gray">
            {required && ' *'}
          </Text>
        </Text>
        <Group gap="xs" c="gray">
          <Text fz="xxxs" c="gray">
            {`${ratio} ratio or ${dimensions[0]} x ${dimensions[1]} pixels`}
          </Text>
          {moreInfo && (
            <Tooltip label={moreInfo} maw={300}>
              <IconInfo size={16} />
            </Tooltip>
          )}
        </Group>
      </Group>
      <FileUpload
        file={file}
        setFile={setFile}
        existingSrc={existingSrc}
        setExistingSrc={setExistingSrc}
        dimensions={dimensions}
        enableCropping={enableCropping}
        {...props}
      />
    </Stack>
  );
};

export { ImageUpload };
